import t from'@mui/material/IconButton';var n=t;export{n as IconButton};//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map